import { AbstractControl, ValidationErrors } from '@angular/forms';

export function minOneItem(control: AbstractControl<Set<unknown>>): ValidationErrors | null {
  if (control.value && control.value.size > 0) {
    return null;
  }
  return { minOneItem: true };
}
